/* eslint-disable indent */
import toast from 'react-hot-toast';
import '../../../css/VideoDisplay.css';
import { VideoInfoCard } from './VideoInfoCardOG';
import { useUser } from '../../../hooks/useUser';
import { useEffect, useMemo, useState } from 'react';
import { EditVideo } from '../../../forms/EditVideoForm';
import { Video } from '../../../interfaces/userInterfaces';
import { useNavigate, useLocation } from 'react-router-dom';
import { usePublicData } from '../../../hooks/usePublicData';
import { deleteUserVideo, updateViews } from '../../../services/fetch-utils';

export const VideoDisplay = (video: Video) => {
  const navigate = useNavigate();
  const location = useLocation();
  const mediaPage = new RegExp('^/media/[0-9]*$');
  const { user, updateUserVideoListAfterAction } = useUser();

  const [isMyvideo, setIsMyVideo] = useState<boolean>(false);
  const [showEditForm, setShowEditForm] = useState<boolean>(false);
  const [showControls, setShowControls] = useState(false);
  const [userData, setUserData] = useState<Video>({
    created_at: '',
    description: '',
    id: 0,
    title: '',
    username: '',
    video: '',
    video_id: 0,
    video_name: '',
    views: 0,
  });

  const { dispatch } = usePublicData();

  useEffect(() => {
    if (mediaPage.test(location.pathname)) {
      setShowControls(true);
      setUserData(location.state.video);
    } else {
      setUserData(video);
    }
  }, [video]);

  useEffect(() => {
    const userInStorage = localStorage.getItem('user');
    if (
      userInStorage &&
      JSON.parse(userInStorage!).username === video.username &&
      location.pathname !== '/' &&
      !mediaPage.test(location.pathname)
    ) {
      setIsMyVideo(true);
    }
  }, []);

  const verifyDelete = () => {
    toast((t) => (
      <span>
        <b>
          {`Are You Sure You Want To Delete This Video?
                   This Action Cannot Be Undone`}
        </b>
        <button
          onClick={() => {
            handleDelete();
            toast.dismiss(t.id);
          }}
        >
          Yes, I Want To Delete Video
        </button>
        <button onClick={() => toast.dismiss(t.id)}>No, I Do Not Want To Delete Video</button>
      </span>
    ));
  };

  const handleDelete = async () => {
    if (user?.user_id && isMyvideo) {
      const deleteVideoAction = await deleteUserVideo(
        user?.user_id,
        video.video_name,
        video.video_id
      );
      if (deleteVideoAction.status === 204) {
        updateUserVideoListAfterAction(user.user_id);
        toast.success('Video Successfully Deleted');
      } else {
        console.log('AN ERROR OCCURED WHILE UPDATING USER VIDEO ARRAY AFTER DELETE ACTION');
      }
    }
  };

  const videoJsxElement = useMemo(() => {
    return (
      <div
        key={`latest-video-item-${userData.video_id}`}
        className={showControls ? 'public-view' : 'latest-feed-grid'}
      >
        <video
          className={showControls ? 'user-videos-private' : 'user-videos-public'}
          controls={showControls}
          controlsList="nodownload"
          preload={showControls ? 'auto' : 'metadata'}
          onClick={
            showControls
              ? undefined
              : () => {
                  updateViews(userData.video_id);
                  navigate(`/media/${userData.video_id}`, { state: { video } });
                }
          }
          onLoadedData={() => dispatch({ type: 'increment' })}
          src={userData.video!}
        ></video>
        <VideoInfoCard {...userData} />
        {isMyvideo && (
          <div id="user-video-control-panel">
            <button id="delete-my-video-buton" onClick={verifyDelete}>
              Delete Video
            </button>
            <button id="edit-my-video-buton" onClick={() => setShowEditForm(true)}>
              Edit Video
            </button>
          </div>
        )}
        {showEditForm && (
          <EditVideo key={new Date().toString()} video={video} setShowEditForm={setShowEditForm} />
        )}
      </div>
    );
  }, [userData, showEditForm]);

  return <>{videoJsxElement}</>;
};
